import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
	Form,
	Button,
	Col,
	Dropdown,
	Modal,
	NavLink,
	Row,
} from "react-bootstrap";
import { ChevronDown } from "react-feather";
import UploadFileSharpIcon from "@mui/icons-material/UploadFileSharp";
import axios from "../../API/axios";
import defaultImage from "../../../src/assets/images/Default_user_image.png";
import DataTable from "react-data-table-component";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import NoteAddSharpIcon from "@mui/icons-material/NoteAddSharp";
import InsertDriveFileSharpIcon from '@mui/icons-material/InsertDriveFileSharp';
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
import toast from "react-hot-toast";
import { ShimmerDiv } from "shimmer-effects-react";
import error from "../../assets/images/Not-Found.png";
import AssignmentSharpIcon from '@mui/icons-material/AssignmentSharp';
import Flatpickr from "react-flatpickr";


const BulkResume = () => {

	const sessionId = localStorage.getItem("sessionId");
	const [fileName, setFileName] = useState(""); // State to store selected filename
	const fileInputRef = useRef(null); // Reference to hidden file input
	const userUID = localStorage.getItem("userUID");
	const [candidateList, setCandidateList] = useState([]);
	const [search, setSearch] = useState("");
	const [display, setDisplay] = useState(false);
	const [page, setPage] = useState(1);
	const [classGroupBatch, setClassGroupBatch] = useState("All");
	const [groupBatchType, setGroupBatchType] = useState("All"); // going batch type
	const [groupBatchId, setGroupBatchId] = useState(null); // going batch id
	const [show, setShow] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);

	const [selectedCandidateClass, setSelectedCandidateClass] = useState(null); // State for selected class in modal
	const [selectedCandidateBatch, setSelectedCandidateBatch] = useState([]); // State for selected batch in modal
	const [candidateData, setCandidateData] = useState({}); // State for selected batch in modal
	// const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRows, setTotalRows] = useState(1);
	const [currentPage, setCurrentPage] = useState(1);
	const [classList, setClassList] = useState([]); // State to store class options
	const [selectedClass, setSelectedClass] = useState([]); // State for selected class
	const [batchList, setBatchList] = useState([]); // State to store batch options
	const [selectedBatch, setSelectedBatch] = useState(null); // State for selected batch
	const [unAuthorizeError, setUnAuthorizeError] = useState("");
	const [unauthModal, setUnauthModal] = useState(false);
	const handleunauthModal = () => setUnauthModal(true);
	const handlecloseunauthModal = () => setUnauthModal(false);

	// Assigned test 

	const [testRemark, setTestRemark] = useState("");
	const [testName, setTestName] = useState("");

	const [testType, setTestType] = useState([]);
	const [testTypeList, setTestTypeList] = useState(null);

	const [testLink, setTestLink] = useState("");

	const [testPlatform, setTestPlatform] = useState("");
	const [platform, setplatform] = useState(null);

	const [testDuration, setTestDuration] = useState(null);
	const [testSchedule, setTestSchedule] = useState("");
	const [testInstruction, setTestInstruction] = useState("");
	const [jobappId, setjobappId] = useState(null);
	const [jobappNameId, setjobappNameId] = useState("");
	const [candidateId, setCandidateId] = useState("");

	console.log("candidateList", candidateList);


	const [showtestModal, setShowTestModal] = useState(false);
	// const handleTestShow = () => setShowTestModal(true);
	const handleTestShow = (id) => {
		setCandidateId(id);
		setShowTestModal(true);
	};

	const handleCloseTestModal = () => setShowTestModal(false);

	const getTestTypeList = async () => {
		try {
			const response = await axios.get(`/MasterDDL/GetCandidateAssignTestTypesDDL`)
			console.log("GetList==>", response)
			const TestTypeList = response.data.responseData.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setTestType(TestTypeList)
		}
		catch (error) {
			// console.log("GetList==>", error);
		}
	}

	const handleTestType = (selectedOption) => {
		console.log("Selected City:", selectedOption);
		setTestTypeList(selectedOption ? selectedOption.value : null);
	};

	const getplatformList = async () => {
		try {
			const response = await axios.get(`/MasterDDL/GetOnlineProctoringPlatformDDL`)
			console.log("platform==>", response)
			const platformList = response.data.responseData.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setTestPlatform(platformList)
		}
		catch (error) {
			console.log("GetList==>", error);
		}
	}

	const handlePlatform = (selectedOption) => {
		//   console.log("Selected City:", selectedOption); 
		setplatform(selectedOption ? selectedOption.value : null);
	};


	useEffect(() => {
		getTestTypeList();
		getplatformList();
	}, [])



	const TestAsignForInsCandid = async () => {
		try {
			if (!testName || !testTypeList || !testDuration || !testSchedule || !platform || !testLink) {
				toast.error("Fill all the required fields!");
				return;
			}

			if (!/^\d+$/.test(testDuration)) {
				toast.error("Test Duration should be a valid number!");
				return;
			}

			// const urlPattern = /^(http?:\/\/)?([\w\d-]+\.)+[\w]{2,}(\/.*)?$/;
			// const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.[a-zA-Z]{2,}(\/\S*)?$/;
			// const testLink = "https://dev-web.jobbikhoj.com/interviews";

			const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.[a-zA-Z]{2,}(\/\S*)?$/;

			if (!urlPattern.test(testLink)) {
				toast.error("Please enter a valid Test Link!");
				return;
			}

			// if (!urlPattern.test(testLink)) {
			// 	toast.error("Please enter a valid Test Link!");
			// 	return;
			// }

			const requestBody = {
				sessionId: sessionId,
				instnCnddtId: candidateId,
				cnddtType: "InsttCandidate",
				testName: testName,
				testType: testTypeList,
				testDurationMinutes: testDuration,
				scheduledAt: testSchedule,
				platform: platform,
				link: testLink,
				testInstructions: testInstruction,
				remark: testRemark
			};
			console.log("testdetail", requestBody);

			const response = await axios.post(
				"/Institute/AssignTestToCandidate",
				requestBody
			);

			toast.success(response.data.message);
			console.log("response message", response);
			// getInterviewShedule(1, "Institution");

			// JobAppGetAll();
			handleCloseTestModal();
			setTestType("");
			setTestName("");
			setTestRemark("");
			setTestInstruction("");
			setTestDuration(null);
			setTestSchedule("");
			setplatform(null);
			setTestLink("");
			setTestTypeList(null);
			// InstituteCandidateHiringStatus(candData);
		} catch (error) {
			console.log("error====>", error.response.data.status);

			if (error.response.data.status === "Success") {
				handleCloseTestModal();
			}
			// else {

			// }
			toast.error(error.response.data.message);

			// toast.error("Some problem occurred!");
			console.error("API Error:", error);
		}
	};

	const getGetAllCandidate = (page) => {
		setIsLoading(true);
		const data = {
			pageNumber: page,
			pageSize: 10,
		};
		axios
			.post(
				`/Candidate/GetAllByInstt/${userUID}?Type=${groupBatchType}&TypeId=${groupBatchId}&Search=${search}`,
				data
			)
			.then((response) => {
				console.log("test=====>", response);

				const res = response?.data?.responseData || {};
				setCandidateList(res?.items || []);
				setTotalRows(res?.paging?.allDataCount || 1);
				setIsError(res.length === 0); // If no jobs, set error state

				setIsLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setIsError(true);
				setIsLoading(false);
				if (error.response && error.response.status === 409) {
					setUnAuthorizeError(error.response.data.message)
					handleunauthModal()
				} else {
					console.log("error", error);
				}
			});
	};


	useEffect(() => {

		setSelectedCandidateBatch("")
		if (
			classGroupBatch === "All" ||
			(classGroupBatch === "Class" && selectedClass) ||
			(classGroupBatch === "Batch" && selectedBatch)
		) {
			getGetAllCandidate(currentPage);
		}
	}, [groupBatchType, groupBatchId, classGroupBatch, search, selectedClass, selectedBatch, currentPage]);



	console.log("candidateList", candidateList);

	const GetCandidateClass = () => {
		const data = {
			sessionId: sessionId,
			name: "",
			type: "Class",
		};

		axios
			.post(`/Institute/GetCandidateClasses`, data)
			.then((response) => {
				const res = response.data.responseData;
				const data = res.map((item) => ({
					value: item.id,
					label: item.name,
				}));
				setClassList(data);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const GetCandidateBatch = () => {
		const data = {
			sessionId: sessionId,
			name: "",
			type: "Batch",
		};

		axios
			.post(`/Institute/GetCandidateClasses`, data)
			.then((response) => {
				const res = response.data.responseData;
				const data = res.map((item) => ({
					value: item.id,
					label: item.name,
				}));
				setBatchList(data);

			})
			.catch((error) => {
				console.log(error);
				if (error.response && error.response.status === 409) {
					console.error("Unexpected error:", error);
					setUnAuthorizeError(error.response.data.message)
					handleunauthModal()
				} else {
					console.error("Unexpected error:", error);

				}
			});
	};

	useEffect(() => {
		GetCandidateClass();
		GetCandidateBatch();
	}, []);

	const handleShow = (candidate) => {

		// Set class details
		setSelectedCandidateClass({
			value: candidate.insttCandidateProfile.clssID,
			label: candidate.insttCandidateProfile.insttClssName,
		});

		const batches = Array.isArray(candidate.insttCandidateProfile.batchNames)
			? candidate.insttCandidateProfile.batchNames
			: candidate.insttCandidateProfile.batchNames
				? [candidate.insttCandidateProfile.batchNames]
				: [];

		// const batchIDs = Array.isArray(candidate.insttCandidateProfile.btchID)
		// 	? candidate.insttCandidateProfile.btchID
		// 	: candidate.insttCandidateProfile.btchID
		// 		? [candidate.insttCandidateProfile.btchID]
		// 		: [];

		const batchIDs = candidate.insttCandidateProfile.btchID
			? candidate.insttCandidateProfile.btchID.split(",")
			: [];


		const formattedBatches =
			batchIDs.map((batchID, index) => ({
				value: batchID.trim(),
				label: batches[index] || `Batch ${batchID}`,
			}))

		setSelectedCandidateBatch(formattedBatches);
		setCandidateData(candidate);
		setShow(true);
	};


	const handleClose = () => {
		setShow(false);
		setFileName("");
	};

	const tabStyle = (isActive) => ({
		borderBottom: isActive ? "3px solid #feaa00" : "none",
		cursor: "pointer",
		width: "100px",
		height: "50px",
		lineHeight: "50px",
		textAlign: "center",
	});

	console.log("candidateData", candidateData);

	const AddClass = () => {
		const classId = selectedCandidateClass
			? selectedCandidateClass.value
			: candidateData.insttClssId; // Assuming insttClssId is the previous class ID

		const batchIDsForAPI =
			selectedCandidateBatch.length > 0
				? selectedCandidateBatch.map((batch) => batch.value).join(",")
				: candidateData.btchID;

		const insttCnddtId = candidateData.insttCandidateProfile
			? candidateData.insttCandidateProfile.instnCnddtId
			: candidateData.instnCnddtId;

		const data = {

			sessionId: sessionId,
			insttCnddtId: insttCnddtId,
			clssID: classId,
			btchID: batchIDsForAPI, // Send as a comma-separated string
		};

		if (!batchIDsForAPI || batchIDsForAPI.length === 0) {
			toast.error("Please select at least one batch.");
		}
		else {
			axios
				.post(`/Candidate/UpdateInsttCnddtGroup`, data) // Use the correct endpoint for adding/updating the candidate
				.then((response) => {
					// Optionally, you may want to fetch updated candidate data or close the modal here
					resetForm();
					getGetAllCandidate(0); // Refresh the candidates list after updating
					toast.success(response.data.message);
				})
				.catch((error) => {
					console.log("Error updating candidate:", error);
					toast.error(error.response.data.message);
				});
		}
	};

	const resetForm = () => {
		setSelectedCandidateClass(null);
		handleClose();

	};

	const handleCloseBulkResume = () => {
		resetForm(); // Call resetForm when closing the modal
		handleClose();
	};


	const columns = [
		{
			name: "NAME",
			// center: true,
			sortable: true,
			cell: (row) => (
				<div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
					{/* Row for Image and Username */}
					<Link
						to={`/Resume?userUID=${userUID}&InstnCnddtId=${row.insttCandidateProfile.instnCnddtId}`}

						style={{ color: 'unset' }}>
						<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
							<div>
								<img
									src={row.profileImage}
									alt="User"
									style={{ width: "35px", height: "35px", borderRadius: "50%" }}
								/>
							</div>
							<div className="flex flex-column">
								<div className="pointer mb-1 f-700">{row.firstName}</div>
								<div className="pointer fw-normal">{row.lastName}</div>
							</div>


						</div>
					</Link>
				</div>
			),
		},
		{
			name: "GENDER",
			center: true,
			sortable: true,
			selector: (row) => row.genderName,
		},
		{
			name: "CLASS NAME",
			center: true,
			sortable: true,
			selector: (row) => row.insttCandidateProfile.insttClssName,
		},
		{
			name: "BATCH NAME",
			center: true,
			sortable: true,
			selector: (row) => {
				const batchNames = Array.isArray(row.insttCandidateProfile.batchNames)
					? row.insttCandidateProfile.batchNames
					: [];
				return batchNames.length > 0 ? batchNames.join(" , ") : '';
			}
		},
		{
			name: "ACTION",
			center: true,
			cell: (row) => (
				<>
					<Tooltip title="Update group" arrow>
						<GroupSharpIcon
							className="me-2 pointer"
							onClick={() => handleShow(row)}
						/>
					</Tooltip>

					<Link to={`/Institute/Candidate/Update/${row.cnddtUID}`}>
						<Tooltip title="Edit" arrow>
							<EditIcon className="edit-icon Dark-icon-color" />
						</Tooltip>
					</Link>
					<Link
						to={`/Resume/${row.insttCandidateProfile.instnCnddtId}/Manage`}
						className="ms-2"
						state={{ cnddtId: row.instnCnddtId }}
					>
						<Tooltip title="Manage" arrow>
							<InsertDriveFileSharpIcon className="edit-icon Dark-icon-color" />
						</Tooltip>
					</Link>
					<Link
						target="blank"
						to={`/Resume?userUID=${row.cnddtUID}&InstnCnddtId=${row.insttCandidateProfile.instnCnddtId}`}

					>
						<Tooltip title="View" arrow>
							<VisibilitySharpIcon
								style={{ cursor: "pointer", color: "black" }}
								className="ms-2 joblist-eye-icon Dark-icon-color"
							/>
						</Tooltip>
					</Link>

					<span className="ms-2 ">
						<Tooltip title="Assign Test" arrow>
							<AssignmentSharpIcon
								onClick={() => {
									handleTestShow(row?.insttCandidateProfile?.instnCnddtId);
									// setCandidateId(row?.insttCandidateProfile?.instnCnddtId);
									// setjobappId(row?.jbApplctnId);
								}}
							/>
						</Tooltip>
					</span>
				</>
			),
		},
	];


	// const handlePageChange = (pageNumber) => {
	// 	// setPage(pageNumber - 1);
	// 	getGetAllCandidate(pageNumber + 1);
	// };

	const handleTabChange = (tab) => {
		const type = tab === 1 ? "Class" : tab === 2 ? "Batch" : "All";
		setGroupBatchType(type); // Update type
		setGroupBatchId(0); // Reset ID
		setClassGroupBatch(type); // Update displayed tab
		setSelectedClass(null); // Clear selected class
		setSelectedBatch(null); // Clear selected batch
		setCandidateList([]); // Clear candidate list
	};

	const handleClassChange = (selectedOption) => {
		setSelectedClass(selectedOption); // Update selected class
		setGroupBatchType("Class"); // Set type to "Class"
		setGroupBatchId(selectedOption?.value || 0); // Set groupBatchId
		if (selectedOption) {
			getGetAllCandidate(1); // Fetch candidates for the selected class
		}
	};

	const handleBatchChange = (selectedOption) => {
		setSelectedBatch(selectedOption); // Update selected batch
		setGroupBatchType("Batch"); // Set type to "Batch"
		setGroupBatchId(selectedOption?.value || 0); // Set groupBatchId
		if (selectedOption) {
			getGetAllCandidate(1); // Fetch candidates for the selected batch
		}
	};



	return (
		<>
			<section className="pricing-section-three container jobapplication bulkResume view-job-style application-drop-section">
				<div className="mt-2">
					<h4 className="orange-title">
						<span className="orange-box me-2"></span>
						Manage Candidate
					</h4>
				</div>
				<div className="container st3">
					<div className="tabButton d-flex w-100 ps-0 connectionTab mt-1">
						<NavLink
							onClick={() => handleTabChange(0)}
							style={tabStyle(classGroupBatch === "All")}
						>
							<p className="f-14 m-0 tabName">ALL</p>
						</NavLink>
						<NavLink
							onClick={() => handleTabChange(1)}
							style={tabStyle(classGroupBatch === "Class")}
						>
							<p className="f-14 m-0 tabName">Class</p>
						</NavLink>
						<NavLink
							onClick={() => handleTabChange(2)}
							style={tabStyle(classGroupBatch === "Batch")}
						>
							<p className="f-14 m-0 tabName">Batch</p>
						</NavLink>
					</div>

					<div className="tabContent">
						<div className="manage-search-container">
							<div className="manage-search-bar">
								<SearchIcon className="icon" />
								<input
									type="text"
									placeholder="Search..."
									className="manage-search-input"
									onChange={(e) => setSearch(e.target.value.trim().toLowerCase())}

								/>
							</div>


							{classGroupBatch === "Class" && (
								<div className="dropdown-container">
									<ReactSelect
										options={classList}
										onChange={handleClassChange}
										value={selectedClass}
										placeholder="Select Class"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										isClearable
									/>
								</div>
							)}
							{classGroupBatch === "Batch" && (
								<div className="dropdown-container">
									<ReactSelect
										options={batchList}
										onChange={handleBatchChange}
										value={selectedBatch}
										placeholder="Select Batch"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										isClearable
									/>
								</div>
							)}

							<Link to="/Institute/Candidate/Add"
								className="add-batch-btn manage-button addcand-manage-btn"
							>
								<Link to="/Institute/Candidate/Add"> Add Candidate</Link>
							</Link>

						</div>
					</div>

					<div className="manage-batches-container">
						<h2 className="manage-heading">{classGroupBatch} List</h2>
					</div>


					{/* {isLoading && candidateList.length > 0 ? ( */}
					{isLoading ?
						(<div className="row mt-2">
							<div className="col-md-12 mb-1">
								<ShimmerDiv mode="light" height={100} width={"100%"} />
							</div>
							<div className="col-md-12 mb-1">
								<ShimmerDiv mode="light" height={100} width={"100%"} />
							</div>
							<div className="col-md-12 mb-1">
								<ShimmerDiv mode="light" height={100} width={"100%"} />
							</div>
						</div>
						)

						: classGroupBatch === "Class" && !selectedClass ? (
							<div className="mt-2 error-image-cont error-cont justify-content-center">
								<p className="d-flex justify-content-center">Select a class first.</p>
							</div>
						) : classGroupBatch === "Batch" && !selectedBatch ? (
							<div className="mt-2 error-image-cont error-cont justify-content-center">
								<p className="d-flex justify-content-center">Select a batch first.</p>
							</div>
						) : isError && candidateList.length === 0 ? (
							<div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
								{/* <p className="d-flex justify-content-center">There is no record to display</p> */}
								<img src={error} alt="404 Not Found" width={300} />
							</div>
						) : (
							<div className="scroll-react-dataTable">
								<div className="react-dataTable react-table-colorclass">
									<DataTable
										noHeader
										pagination
										columns={columns}
										data={candidateList}
										progressPending={isLoading}
										paginationServer
										paginationPerPage={10}
										paginationTotalRows={totalRows}
										paginationDefaultPage={currentPage}
										paginationRowsPerPageOptions={[]}
										// onChangePage={(page) => {
										// 	getGetAllCandidate(page);
										// }}
										onChangePage={(page) => {
											setCurrentPage(page); // Update the current page
										}}
										sortIcon={<ChevronDown size={10} />}
										className="react-dataTable"
									/>
								</div>
							</div>
						)}
				</div>
			</section>

			<Modal show={show} onHide={handleCloseBulkResume} centered>
				<Modal.Header>
					<Modal.Title>Update Candidate Group</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseBulkResume} />
				</Modal.Header>
				<Modal.Body className="settings">
					<Row>
						<Col md={12}>
							<Form.Group controlId="Name_Title">
								<Form.Label className="class-type">Class</Form.Label>
							</Form.Group>
							<div className="post-form-group">
								<ReactSelect
									placeholder="Select Class"
									classNamePrefix="react-select"
									className="form-control"
									styles={customStyles}
									options={classList}
									isClearable
									value={
										classList.find(
											(option) => option.value === selectedCandidateClass?.value
										) || null
									} // Set the value based on the selected class
									onChange={(selectedOption) => {
										setSelectedCandidateClass(selectedOption); // Update selected class
									}} // Handle class selection
								/>
							</div>
						</Col>
						<Col md={12} className="mt-2">
							<Form.Group controlId="Name_Title">
								<Form.Label className="class-type">Batch</Form.Label>
							</Form.Group>

							<div className="post-form-group">
								<ReactSelect
									placeholder="Select Batch"
									classNamePrefix="react-select"
									className="form-control"
									styles={customStyles}
									isMulti
									isClearable
									options={batchList} // List of all available batches
									value={selectedCandidateBatch} // Selected batches (ID and name)
									onChange={setSelectedCandidateBatch}

								// onChange={(selectedOptions) => {
								// 	const selectedIDs = selectedOptions.map(
								// 		(option) => option.value
								// 	); // Extract IDs for API
								// 	setSelectedCandidateBatch(selectedOptions); // Update for display
								// }}
								/>
							</div>
						</Col>
					</Row>
					<div className=" mt-4 d-flex justify-content-center">
						<Button onClick={AddClass}>Update</Button>
					</div>
				</Modal.Body>
			</Modal>

			{/* ...............UnAuthorize modal............  */}
			{unAuthorizeError ? (
				<Modal show={unauthModal} centered>
					<Modal.Header>
						<Modal.Title>Unauthorize session expired</Modal.Title>
					</Modal.Header>
					<Modal.Body className="settings">
						<div className=" mb-3">
							<p>{unAuthorizeError}</p>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Link
							className="pointer"
							to="/Login"
							onClick={() => {
								localStorage.removeItem("token"); // Remove authentication token
								sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
								localStorage.removeItem("Module");
							}}
						>
							<button className="btn btn-danger ">Login</button>
						</Link>
						{/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}

					</Modal.Footer>

				</Modal>
			) : (
				""
			)}

			<Modal show={showtestModal} onHide={handleCloseTestModal} centered size="lg">
				<Modal.Header>
					<Modal.Title> Assign Test</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseTestModal} />
				</Modal.Header>
				<Modal.Body>

					<div className="row  mt-2 align-center">

						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Test Name<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>
								<input
									placeholder="Enter Test Name"
									type="text"
									style={{ width: "100%" }}
									value={testName}
									onChange={(e) => setTestName(e.target.value)}
								/>
							</div>
						</Col>
						<Col md={6} className="mb-2">
							<div className="post-form-group text-transform-email">
								<label htmlFor="about" className="f-14 f-700">
									Link<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>
								<input
									placeholder="Enter Link"
									type="text"
									style={{ width: "100%" }}
									value={testLink}
									onChange={(e) => setTestLink(e.target.value)}
								/>
							</div>
						</Col>

						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Test Type<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>

								<ReactSelect
									options={testType}
									onChange={handleTestType} // Select hone ke baad clear ho jaye
									placeholder="Select Test Type"

									classNamePrefix="react-select"
									className="form-control Dark-Input-from-group"
									styles={customStyles}
									isClearable
								/>
							</div>
						</Col>
						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Platform<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>
								<ReactSelect
									options={testPlatform}
									onChange={handlePlatform} // Select hone ke baad clear ho jaye
									placeholder="Select Platform"

									classNamePrefix="react-select"
									className="form-control Dark-Input-from-group"
									styles={customStyles}
									isClearable
								/>
							</div>
						</Col>


						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Test Duration Minutes<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>
								<input
									placeholder="Enter Test Duration"
									type="text"
									style={{ width: "100%" }}
									value={testDuration}
									onChange={(e) => setTestDuration(e.target.value)}
								/>
							</div>
						</Col>
						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14">
									Schedule Time{" "}
									<span style={{ color: "red" }} className="ms-2">
										*
									</span>
								</label>
								<Flatpickr
									data-enable-time
									value={testSchedule}
									onChange={(selectedDates) => {
										setTestSchedule(selectedDates[0]);
									}}
									options={{
										enableTime: true,
										dateFormat: "Y-m-d H:i",
										minDate: new Date(),
										static: true, // Keeps the calendar visible on click         
									}}
									className="form-control Dark-Input-from-group"
									placeholder="Enter schedule time"
								/>
							</div>
						</Col>
						<Col md={12} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Remark
								</label>
								<textarea
									placeholder="Enter Remark"
									type="text"
									style={{ width: "100%" }}
									value={testRemark}
									onChange={(e) => setTestRemark(e.target.value)}
								/>
							</div>
						</Col>
					</div>
					<div className="row">

						<Col md={12} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="about" className="f-14 f-700">
									Instructions
								</label>
								<textarea
									placeholder="Enter Instruction"
									type="text"
									style={{ width: "100%" }}
									value={testInstruction}
									onChange={(e) => setTestInstruction(e.target.value)}
								/>
							</div>
						</Col>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn khojPrimaryBtn"
						onClick={() => {
							TestAsignForInsCandid();
						}}
					>
						Submit
					</button>
				</Modal.Footer>
			</Modal>

		</>
	);
};

export default BulkResume;
